import { ThemeColors } from '../theme-colors';
import { ColorPalette } from '../../base/colorPalette';

export const Buttons = {
	buttonPrimaryFill: ThemeColors.primary,
	buttonPrimaryText: 'var(--epods--color-text-button)',
	buttonPrimaryHover: 'var(--epods--color-bg-primary-hover)',
	buttonPrimaryActive: 'var(--epods--color-bg-primary-active)',
	buttonPrimarySelectedFill: 'var(--epods--color-bg-primary-active)',
	buttonPrimarySelectedText: 'var(--epods--color-text-button)',
	buttonPrimarySpinnerForeground: '#F6F6F6',
	buttonPrimarySpinnerBackground: '#757575',

	buttonSecondaryFill: 'var(--epods--color-bg-secondary)',
	buttonSecondaryText: 'var(--epods--color-text-button-secondary)',
	buttonSecondaryHover: 'var(--epods--color-bg-secondary-hover)',
	buttonSecondaryActive: 'var(--epods--color-bg-secondary-active)',
	buttonSecondarySelectedFill: 'var(--epods--color-bg-secondary-active)',
	buttonSecondarySelectedText: 'var(--epods--color-text-button-secondary-active)',
	buttonSecondarySpinnerForeground: '#333333',
	buttonSecondarySpinnerBackground: '#CBCBCB',

	buttonOutlineFill: 'var(--epods--color-background-btn-outline)',
	buttonOutlineHover: 'var(--epods--color-border)',
	buttonOutlineActive: 'var(--epods--color-border-active)',
	buttonOutlineDisabledFill: 'var(--epods--color-border-light)',

	buttonTertiaryFill: 'transparent',
	buttonTertiaryText: 'var(--epods--color-text-ds-blue)',
	buttonTertiaryHover: 'transparent',
	buttonTertiaryActive: '#EEEEEE',
	buttonTertiarySelectedFill: 'transparent',
	buttonTertiarySelectedText: ThemeColors.black,
	buttonTertiarySpinnerForeground: '#333333',
	buttonTertiarySpinnerBackground: '#CBCBCB',

	buttonMinimalFill: 'transparent',
	buttonMinimalText: '#1C2E45',
	buttonMinimalHover: 'transparent',
	buttonMinimalActive: 'transparent',
	buttonMinimalSelectedFill: 'transparent',
	buttonMinimalSelectedText: 'var(--epods--color-btn-link-active)',
	buttonMinimalSpinnerForeground: '#333333',
	buttonMinimalSpinnerBackground: '#CBCBCB',

	buttonDisabledFill: 'var(--epods--color-bg-primary-disabled)',
	buttonDisabledText: 'var(--epods--color-text-button)',
	buttonDisabledSpinnerForeground: '#AFAFAF',
	buttonDisabledSpinnerBackground: '#E2E2E2',
};

//Add here custom vars
export const customButtons = {};
